export const FAQS_LINK = 'https://paymentshield.helpshift.com/hc/en/';
export const TWITTER_LINK = 'http://twitter.com/paymentshield';
